module.exports = __webpack_public_path__ + "img/menu-bg.8b67a99c.jpg";